export type AnalyticsProps = Record<string, unknown>;

/** Drop empty values so destinations do not store noise. */
export function omitEmpty(props?: AnalyticsProps): AnalyticsProps {
  const out: AnalyticsProps = {};
  if (!props) return out;
  for (const [key, value] of Object.entries(props)) {
    if (value !== undefined && value !== null && value !== "") {
      out[key] = value;
    }
  }
  return out;
}
